<ion-header>
  <ion-toolbar>
    <ion-title>Rate Listing</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCloseModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <curbnturf-rating-poi [poi]="poi" [appContext]="true"></curbnturf-rating-poi>
</ion-content>
